import { Copy } from '@stokr/components-library'
import type { CopyKey } from 'locales/copy-keys.gen'
import { formatChartMoney, formatChartMoneyShort, formatChartPercent } from 'components/ui/chart'
import type { ChartRangeId, ChartReadout } from 'models/chart'
import { TokenIcon } from './TokenIcon'
import { Change, Identity, IdentityText, RangeTag, SymbolLine, Value, ValueLine } from './chart.styles'

interface ChartIdentityProps {
  /** Shown before the symbol only when set (equity: the underlying stock's logo). */
  icon?: string
  symbol: string
  labelKey: CopyKey
  currency: string
  readout: ChartReadout
  /** The range the change is over, shown after it ("+13.74% YTD") where no range tabs show it. */
  range?: ChartRangeId
  /** Shortens a value from a million up (`$939.7M`): the collapsed hero card, where a full one crowds the row. */
  short?: boolean
  /** The label names the symbol itself ("BTC mined per BMN2"), so no "BMN2 -" before it. */
  symbolInLabel?: boolean
}

/** Optional logo, "SYMBOL - label", and the value with its change — the chart cards' header. */
export const ChartIdentity = ({
  icon,
  symbol,
  labelKey,
  currency,
  readout,
  range,
  short = false,
  symbolInLabel = false,
}: ChartIdentityProps) => (
  <Identity>
    {icon && <TokenIcon key={icon} sources={[icon]} size={32} bare />}
    <IdentityText>
      <SymbolLine>
        {symbol && !symbolInLabel && <strong>{symbol} - </strong>}
        <Copy id={labelKey} values={{ symbol }} />
      </SymbolLine>
      <ValueLine>
        <Value>{(short ? formatChartMoneyShort : formatChartMoney)(readout.value, currency)}</Value>
        {readout.percent !== undefined && <Change $tone={readout.tone}>{formatChartPercent(readout.percent)}</Change>}
        {readout.percent !== undefined && range && <RangeTag>{range}</RangeTag>}
      </ValueLine>
    </IdentityText>
  </Identity>
)
